<template>
    <div>
        <!-- 移动端卡片模式 -->
        <div v-if="cardMode"
            class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
            <div class="card-body p-4">
                <button @click="openIndexDialog"
                    class="flex items-center justify-between w-full text-left">
                    <div class="flex items-center space-x-3">
                        <div class="p-2 bg-info/10 rounded-lg">
                            <svg-icon name="file-index" class="w-6 h-6 fill-info" />
                        </div>
                        <div>
                            <div class="font-medium text-base-content">文件索引</div>
                            <div class="text-sm text-base-content/70">增量或重建音乐索引</div>
                        </div>
                    </div>
                    <div class="flex-shrink-0">
                        <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                        <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                            <path fill-rule="evenodd"
                                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                                clip-rule="evenodd" />
                        </svg>
                    </div>
                </button>
            </div>
        </div>

        <!-- 桌面端原有模式 -->
        <div v-else :class="['flex', 'flex-col', 'gap-2', detail ? 'w-full' : 'items-center']">
            <!-- 文件索引按钮 -->
            <button :theme="'success'" @click="openIndexDialog"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content', !detail ? 'tooltip tooltip-top' : '']"
                data-tip="文件索引" :disabled="isLoading">
                <span class="loading loading-infinity loading-md" v-if="isLoading"></span>
                <span v-else :class="['flex', 'items-center', detail ? 'w-40' : '']">
                    <svg-icon name="file-index" class="w-16 h-6 fill-current" />
                    <div v-if="detail" class="mr-auto">文件索引</div>
                </span>
            </button>
        </div>

        <!-- 文件索引弹窗 -->
        <dialog id="file_index" ref="file_index" class="modal modal-bottom sm:modal-middle">
            <div class="modal-box md:overflow-y-visible">
                <h3 class="text-lg font-bold">文件索引管理</h3>
                <div class="py-4 z-20">
                    <!-- 索引描述 -->
                    <div class="mb-6">
                        <div class="alert">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24"
                                class="stroke-current shrink-0 w-6 h-6">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                    d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <div>
                                <h4 class="font-bold">关于文件索引</h4>
                                <div class="text-sm mt-1">
                                    <p>• <strong>增量索引：</strong>只扫描新增或修改的文件，速度较快，适合日常维护</p>
                                    <p>• <strong>重建索引：</strong>完全重新扫描所有文件，耗时较长，适合初次建库或修复数据</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 索引选项表单 -->
                    <form @submit.prevent="submitIndex">
                        <!-- 索引类型选择 -->
                        <div class="form-control mb-4">
                            <label class="label">
                                <span class="label-text font-semibold">索引类型</span>
                            </label>
                            <div class="flex gap-4">
                                <label class="label cursor-pointer">
                                    <input type="radio" name="indexType" value="incremental" v-model="indexForm.type"
                                        class="radio radio-primary" />
                                    <span class="label-text ml-2">增量索引</span>
                                </label>
                                <label class="label cursor-pointer">
                                    <input type="radio" name="indexType" value="rebuild" v-model="indexForm.type"
                                        class="radio radio-primary" />
                                    <span class="label-text ml-2">重建索引</span>
                                </label>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="modal-action">
                    <form method="dialog">
                        <button type="button" class="btn btn-ghost btn-sm" @click="closeIndexDialog">
                            取消
                        </button>
                        <button v-if="userRole === 'V2'" type="submit" class="btn btn-neutral btn-sm"
                            :class="{ 'loading': isSubmitting }" :disabled="isSubmitting">
                            {{ isSubmitting ? '处理中...' : '开始索引' }}
                        </button>
                        <button v-else class="btn btn-neutral btn-sm">
                            开始索引(V2功能)
                        </button>
                    </form>
                </div>
            </div>
        </dialog>
    </div>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'
export default {
    name: 'FileIndexer',
    components: {
        SvgIcon
    },
    props: {
        detail: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        checkedData: {
            type: Array,
            default: () => []
        },
        filePath: {
            type: String,
            default: ''
        },
        userRole: {
            type: String,
            default: ''
        },
        cardMode: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showDialog: false,
            isSubmitting: false,
            indexForm: {
                type: 'incremental', // incremental 或 rebuild
            }
        }
    },
    methods: {
        // 打开索引对话框
        openIndexDialog() {
            console.log("sss")
            this.$refs.file_index.showModal()
            // 重置表单
            this.indexForm = {
                type: 'incremental',
            }
        },

        // 关闭索引对话框
        closeIndexDialog() {
            this.$refs.file_index.close()
            this.isSubmitting = false
        },

        // 提交索引任务
        async submitIndex() {
            if (this.isSubmitting) return

            try {
                this.isSubmitting = true
                this.$emit('loading-start')

                // 准备索引参数
                const indexParams = {
                    select_data: this.checkedData,
                    file_full_path: this.filePath,
                    mode: this.indexForm.type
                }

                // 调用API创建索引任务
                this.$api.Task.fileIndex(indexParams).then(response => {
                    if (response.result) {
                        this.$myMsg.notify({
                            title: '索引任务已启动',
                            content: '任务在后台努力运行中，请查看任务进度',
                            type: 'success',
                            time: 2000,
                            url: '/#/log'
                        })
                        this.closeIndexDialog()

                    } else {
                        this.$myMsg.notify({
                            title: '启动索引任务失败',
                            content: response.message || '未知错误',
                            type: 'error',
                            time: 5000
                        })
                    }
                })

            } catch (error) {
                console.error('创建索引任务失败:', error)
                this.$myMsg.notify({
                    title: '启动索引任务失败',
                    content: error.message || '网络错误',
                    type: 'error',
                    time: 5000
                })
            } finally {
                this.isSubmitting = false
                this.$emit('loading-end')
            }
        },
    }
}
</script>

<style scoped>
.modal {
    z-index: 1000;
}

.collapse-content {
    padding-top: 1rem;
}

.alert {
    padding: 1rem;
}

.alert p {
    margin: 0.25rem 0;
}
</style>